import React, {useRef, useState} from "react";
import styled from "styled-components";
import PopupCustom from "components/ui/popup/Custom";

import {getScheduleStateColor, getScheduleStateName} from "utils/define";

import Tooltip from "components/ui/Tooltip";
import Button from "components/ui/Button";
import Badge from "components/ui/Badge";



/**
 * [스케줄 상세 - 예약자 목록]
 */

export const ReservationList = ({mode, data, ...props}) => {
	const popupRef = useRef();
	const maxLength = 16;	// 목록에 표시 개수
	const isComplete = (new Date(data.startDate) < new Date() && data.scheduleState != "C");

	const reservationInfo = {
		reservation : {title : "예약 출석 현황", state : ["R", "E", "A"]},
		wait : {title : "예약 대기중인 회원", state : ["W"]},
		cancel : {title : "예약 취소", state : ["C"]}
	}[mode];

	const sectionType = mode;
	const sectionTitle = reservationInfo.title;
	const scheduleState = reservationInfo.state;

	let reservationList = (data.orderedClassScheduleMembers || []).filter(item => {
		return (scheduleState.indexOf(item.scheduleState) > -1);
	});
	const reservationLength = reservationList.length;
	const sectionCountColor = (reservationLength) ? (scheduleState.indexOf("C") > -1) ? "red" : "blue" : "gray";

	const isUseSeat = (data.seatUseYn == "Y" && mode == "reservation");

	if(isUseSeat) {
		reservationList.sort((a, b) => {
			a = a.seatNo || 0;
			b = b.seatNo || 0;
			return (a < b) ? 1 : (a > b) ? -1 : 0;
		});
	}

	let li = reservationList.map((item, index) => {
		const state = item.scheduleState;
		const stateColor = getScheduleStateColor(state);
		const stateName = getScheduleStateName(state);
		const getStateInfo = () => {
			switch(state) {
				case "C" : return "예약취소";
				case "E" :
				case "A" :
					const lessonAmount = item.lessonAmount || 1;
					return stateName + " -" + lessonAmount;
				case "W" :
					return stateName + " " + (index + 1);
				case "R" :
					return (isUseSeat) ? (item.seatNo) ? stateName + " " + item.seatNo : "좌석 미지정" : stateName + " " + (index + 1);
			}
			/*
			if(isComplete) {
				const lessonAmount = item.lessonAmount || 1;
				return stateName + " -" + lessonAmount;
			} else {
				return stateName + " " + (isUseSeat ? item.seatNo || "미지정" : (index + 1));
			}
			*/
		};

		return (
			<li key={item.seqSchedule}>
				<div>
					<h4>{item.memberName || "-"}</h4>
					<h5 className={stateColor}>{getStateInfo()}</h5>
				</div>
				{item.naverBookingYn === "Y" && <Badge color="green">네이버 예약</Badge>}
			</li>
		)
	});

	if(!li.length) {
		const scheduleStateName = (scheduleState == "W") ? "대기중인" : (scheduleState == "C") ? "예약 취소한" : "예약된";
		li.push(<li key={0} className="empty">아직 {scheduleStateName} 회원이 없어요</li>);
	}

	const eventHandler = {
		close : () => {
			popupRef.current.close();
		}
	};

	const getTooltip = () => {
		return (
			<StyledDiv>
				<ul>
					<li>
						<Badge color="blue">예약 1</Badge>
						<p>
							예약한 순번, 좌석지정제인 경우 예약한 좌석번호
						</p>
					</li>
					<li>
						<Badge color="blue">좌석 미지정</Badge>
						<p>수업의 좌석 예약 설정을 변경하여 좌석 지정 없이 예약된 경우</p>
					</li>
					<li>
						<Badge color="green">출석 -1</Badge>
						<p>출석 차감 횟수</p>
					</li>
					<li>
						<Badge color="red">결석 -1</Badge>
						<p>결석 차감 횟수</p>
					</li>
					<li>
						<Badge color="gray">대기 3</Badge>
						<p>대기한 순번</p>
					</li>
					<li>
						<Badge color="green">네이버 예약</Badge>
						<p>네이버 예약으로 등록된 회원</p>
					</li>
				</ul>
			</StyledDiv>
		);
	};

	const className = mode + " color";
	return (
		<Wrapper className={className} {...props}>
			<h4>
				{sectionTitle}
				<span className={sectionCountColor}>
					{reservationLength}
				</span>
				{
					(mode == "reservation") ?
						<Tooltip
							title="예약 출석 현황 안내"
							content={getTooltip()}
						/> : null
				}
			</h4>
			<ul>{li.slice(0, maxLength)}</ul>
			{(reservationLength > maxLength) ? (
				<PopupCustom
					ref={popupRef}
					title={sectionTitle}
					element={
						<Wrapper className={className}>
							<h4>
								{sectionTitle}
								<span className={sectionCountColor}>
									{reservationLength}
								</span>
								<button onClick={eventHandler.close}>닫기</button>
							</h4>
							<ul>{li}</ul>
						</Wrapper>
					}
				>
					<Button color="blue" outline>{sectionTitle} 전체 보기</Button>
				</PopupCustom>
			) : null}
		</Wrapper>
	);
};



const Wrapper = styled.section`
& > h4					{font-weight:600}
& > h4 span				{margin-left:5px}
& > h4 button			{float:right; margin:0; background-color:white; border:none}

ul						{display:flex; margin:0 -6px; justify-content:left; flex-wrap:wrap; text-align:center}
ul li					{padding:18px 6px 0 6px; width:calc(100% / 4)}
ul li.empty				{padding:40px 0 20px 0; width:100%; font-size:var(--15px); color:#929aa9}
ul li div				{border-radius:6px; border:1px solid var(--border)}
ul li h4				{padding:12px 6px; font-size:var(--14px); font-weight:600; text-overflow:ellipsis; white-space:nowrap; overflow:hidden}
ul li h5				{padding:6px 2px; letter-spacing:-0.5px; font-size:var(--12px); font-weight:600}
ul li h5.red			{background-color:#fff0f0}
ul li h5.blue			{background-color:#ecf1ff}
ul li h5.green			{background-color:rgba(0,170,129,0.1)}
&.wait ul li h5			{background-color:#f3f3f4; color:#838791}
&.cancel ul li h5		{background-color:#f3f3f4; color:var(--red)}
ul li .badge			{margin-top:6px; padding:2px 6px; font-size:11px; line-height:1.3; border:none}

button					{margin-top:20px}
`;



const StyledDiv = styled.div`
ul						{margin-top:15px; font-size:13px; color:var(--darkGray)}
ul li					{display:flex; align-items:center; flex-wrap:wrap}
ul li + li				{margin-top:10px}
ul li div				{margin-right:10px; width:70px; font-size:12px}
ul li p					{width:calc(100% - 80px)}
ul li .badge			{font-weight:600}
`;

export default ReservationList;